module.exports = __webpack_public_path__ + "static/pro-banner12@2x-cf6282af713a20035db4e1bbd8f4e2ff.jpg";